import { type IRepeatableWidgetProps } from './RepeatableWidgetComponent.tsx';
import { RepeatableContainer } from './style/RepeatableContainer.tsx';

export function RepeatableWidgetPreview(props: IRepeatableWidgetProps) {
  const { widget } = props;

  return (
    <RepeatableContainer
      description={widget.description}
      buttonText={widget.layout?.buttonText}
      hideNumberItems={widget.layout?.hideNumberItem}
      hideBorder={widget.layout?.hideBorder}
      hideAddButton={widget.layout?.hideAddButton}
      label={widget?.label}
    >
      {props.children}
    </RepeatableContainer>
  );
}
